<!--
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2024-12-20 15:43:02
 * @Description: file content
-->

<template>
  <div id="app">
    <div class="app_content">
      <!-- <img
        class="dhl theme_bg_color"
        src="./assets/default/dhl_w.png"
      /> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
@import url("./assets/css/common.less");
:root {
  --callNumberStart: rgb(190, 28, 66);
  --themeColor: rgb(190, 28, 66);
  --themeColor1: rgba(190, 28, 66, 0.1);
  --themeColor2: rgba(190, 28, 66, 0.2);
  --themeColor3: rgba(190, 28, 66, 0.3);
  --themeColor4: rgba(190, 28, 66, 0.4);
  --themeColor5: rgba(190, 28, 66, 0.5);
  --themeColor6: rgba(190, 28, 66, 0.6);
  --themeColor7: rgba(190, 28, 66, 0.7);
  --themeColor8: rgba(190, 28, 66, 0.8);
  --themeColor9: rgba(190, 28, 66, 0.9);
  --font12: 12px;
}
html,
body,
#app,
.app_content,
.self_content {
  height: 100%;
  width: 100%;
}

* {
  padding: 0;
  margin: 0;
  font-family: PingFangSC-Medium;
}
.overflowHidden {
  overflow: hidden !important;
}
/* 禁止 長按圖片展示圖片 */
.self_body img {
  pointer-events: none;
}
/* pc 適配 */

.pc_content {
  /* 超小型设备（电话，600px 及以下） */
  @media only screen and (max-width: 600px) {
    .self_body {
      width: 65%;
      height: calc(100% - 94px);
      padding-top: 94px;
    }
  }

  /* 小型设备（纵向平板电脑和大型手机，600 像素及以上） */
  @media only screen and (min-width: 600px) {
    .self_body {
      width: 65%;
      height: calc(100% - 94px);
      padding-top: 94px;
    }
  }
  /* 中型设备（横向平板电脑，768 像素及以上） */
  @media only screen and (min-width: 768px) {
    .self_body {
      width: 65%;
      height: calc(100% - 94px);
      padding-top: 94px;
    }
  }
  /* 大型设备（笔记本电脑/台式机，992px 及以上） */
  @media only screen and (min-width: 992px) {
    .self_body {
      width: 65%;
      height: calc(100% - 94px);
      padding-top: 94px;
    }
  }
  /* 超大型设备（大型笔记本电脑和台式机，1200px 及以上） */
  @media only screen and (min-width: 1200px) {
    .self_body {
      width: 65%;
      height: calc(100% - 94px);
      padding-top: 94px;
    }
  }
}

.pc_content .self_content .self_body::-webkit-scrollbar {
  /* display: none; */
}
.pc_content .self_content {
  display: flex;
  justify-content: center;
}

.pc_content {
  .couponList-box,
  .print-box,
  .couponDetail-box {
    .download {
      position: absolute !important;
    }
    .self_body {
      padding: 0 !important;
      height: calc(100% - 44px) !important;
      width: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(88, 88, 88, 0.2);
        background: #a09f9f;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
    }
  }
}

/* 適配結束 */

.self_body {
  height: calc(100% - 44px);
  padding-top: 44px;
}
.self_refresh {
  min-height: 100%;
}
.self_disable_bg_color {
  background-color: rgb(220, 220, 220) !important;
  border-color: rgb(220, 220, 220) !important;
}
/* 全局 下拉刷新 */
.self_refresh_doge {
  width: 40px;
}
.self_no_data {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.self_no_data img {
  width: 120px;
}

.B_CCC {
  background-color: #ccc;
}
.B_B_B0ACAF {
  background-color: #b0acaf !important;
  border-color: #b0acaf !important;
}

.B_EFEFF4 {
  background-color: #efeff4;
}
.B_FFF {
  background-color: #fff;
}
.B_BFBFBF {
  background-color: #bfbfbf;
}
.CB-868686 {
  color: #868686 !important;
  border: 1px solid #868686 !important;
}
.B-868686 {
  background-color: #868686 !important;
}
.C_BFBFBF {
  color: #bfbfbf;
}
.C_BE1C42 {
  color: #be1c42;
}
.self_tabs .van-tabs__wrap {
  position: fixed;
  width: 100%;
  z-index: 20;
  box-shadow: 0 1px 6px #ccc;
}
/* 隐藏 友盟的 小玩意 */
a[title="站长统计"] {
  display: none;
}

/* app 訂單列表 */
.app_order_list .van-tabs__line {
  width: 33.3%;
}
.app_order_list .van-tabs .van-tabs__wrap {
  position: fixed;
  z-index: 10;
  width: 100%;
}
.app_order_list .van-tabs .van-tabs__content {
  padding-top: 44px;
}
.app_order_list .self_refresh .van-pull-refresh__head,
.app_order_list .self_refresh .van-list__finished-text,
.app_order_list .self_refresh .van-list__loading {
  background-color: #efeff4;
}
.app_no_ab::after,
.app_no_ab::before {
  border: 0;
}

.pc_content .self_tabs .van-tabs__wrap {
  display: none;
}

.pc_content .van-badge {
  font-size: 16px !important;
}
.pc_content input {
  font-size: 18px;
}
.pc_content .login-country-box .van-cell {
  font-size: 18px;
}

.popular-restaurants {
  width: calc(100% - 56px);
  background-color: #fff;
  border-radius: 10px;
  .popup-top-title {
    padding: 12px 0;
    background-color: #fff;
    z-index: 1;
    .title {
      text-align: center;
    }
  }
  .item-box {
    height: 340px;
    overflow: hidden auto;
    .item {
      margin: 0 10px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      justify-content: space-between;
      height: 84px;
      .left {
        width: calc(100% - 100px);
        height: 54px;
        position: relative;
        .title {
          font-size: var(--font14);
          font-weight: 500;
          color: #333333;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .time {
          font-size: var(--font13);
          font-weight: 400;
          color: #999999;
        }
        .address {
          font-size: var(--font13);
          font-weight: 400;
          color: #666666;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          word-break: break-all;
          position: absolute;
          margin-right: 50px;
        }
      }
      .way-image {
        display: flex;
        align-items: center;
        margin-left: 30px;
        .way {
          font-size: var(--font12);
          font-weight: 400;
          color: #999999;
          word-break: keep-all;
        }
        .image {
          margin-left: 10px;
          border-radius: 8px;
          width: 30px;
        }
      }
    }
  }

  .van-popup__close-icon--top-right {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    top: 6px;
    right: 8px;
  }
}

.no-brand-error {
  z-index: 5001 !important;
}
.no-brand-error-overlay {
  z-index: 5000 !important;
}

.clearShopCart {
  z-index: 5001 !important;
  // * 自主点餐机 适配
  &.isKiosk {
    font-size: 1rem !important;
    width: 20rem;
    border-radius: 1rem;
    .van-dialog__header {
      padding-top: 1.625rem;
      line-height: 1.5rem;
    }
    .van-dialog__content {
      .van-dialog__message {
        font-size: 0.875rem !important;
        padding: 1.625rem 1.5rem;
        line-height: 1.25rem;
        padding-top: 0.5rem;
      }
    }
    .van-dialog__footer {
      .van-button {
        height: 3rem;
        font-size: 1rem;
        border-radius: 0.125rem;
        .van-button__text{
          font-size: 1rem !important;
        }
      }
    }
  }
}

.overlayClearShopCart {
  z-index: 5000 !important;
}
</style>
